export default "__VITE_ASSET__DvrekpZn__"